<template>
  <Button
    as="a"
    variant="link"
    :href="href"
    target="_blank"
    append-icon="arrow-up-right-from-square"
  >
    {{ label }}
  </Button>
</template>

<script setup lang="ts">
defineProps<{
  href: string
  label: string
}>()
</script>
